<template>
  <div class="d-flex mb-n3 ticker-container">
    <div style="width: 88vw" class="tradingview-widget-container">
      <div class="tradingview-widget-container__widget"></div>
      <VueScriptComponent script='
        <script type="text/javascript" src="https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js" async>
    {
  "symbols": [
    {
      "proName": "OANDA:SPX500USD",
      "title": "S&P 500"
    },
    {
      "proName": "OANDA:NAS100USD",
      "title": "Nasdaq 100"
    },
    {
      "proName": "FX_IDC:EURUSD",
      "title": "EUR/USD"
    },
    {
      "proName": "BITSTAMP:BTCUSD",
      "title": "BTC/USD"
    },
    {
      "proName": "BITSTAMP:ETHUSD",
      "title": "ETH/USD"
    }
  ],
  "colorTheme": "light",
  "isTransparent": false,
  "displayMode": "adaptive",
  "locale": "es",
}
  </script>
'></VueScriptComponent>
    </div>
    <p class="by-text text-start pa-2 mb-n2" v-html="$t('ctaTradingView')"/>
  </div>
</template>

<script>
    import VueScriptComponent from 'vue-script-component';

    export default {
        name: "TickerTape",
        components: {
            VueScriptComponent,
        },
        data(){
            return {
                legacyHtml: `
                <div class="tradingview-widget-container">
                  <div class="tradingview-widget-container__widget"></div>
                  </div>
                `
            };
        },
        mounted() {
        },
    }
</script>

<style scoped>
.ticker-container {
  background-color: #FFFFFF !important;
}

.by-text {
  font-size: 12px;
}
</style>

<i18n>
{
  "en" : {
    "ctaTradingView": "Quotes by <a href='https://www.tradingview.com/' style='font-size: 12px' target='_blank'>TradingView</a>"
  },
  "es": {
    "ctaTradingView": "Precios por <a href='https://www.tradingview.com/' style='font-size: 12px' target='_blank'>TradingView</a>"
  }
}
</i18n>
